import React from "react";
import { TypeaheadFormField, TypeaheadProps } from "~/components/typeahead";
import { FormFieldProps } from "~/components/forms/FormFieldProps";
import {
  ServiceDescription,
  useServiceDescriptionsAsync,
} from "~/refdata2/serviceDescriptions";
import { createSearchRegex } from "~/components/text-highlighter/createSearchRegex";
import { TextHighlighter } from "~/components/text-highlighter";
import _ from "lodash";

const format = (
  item: ServiceDescription,
  searchText: string
): React.ReactNode => {
  const searchRegex = createSearchRegex(searchText);

  return (
    <div className="service-description-picker-menuitem">
      <TextHighlighter text={item.displayName} search={searchRegex} />
    </div>
  );
};

const chipFormat = (item: ServiceDescription) => item.displayName;

const ServiceDescriptionPicker: React.FC<FormFieldProps> = (props) => {
  const getItems = useServiceDescriptionsAsync();

  const getData = async (searchText: string) => {
    const unorderedResult = ((await getItems()) ?? []).filter(
      (x) => x.isActive
    );
    const result = _.orderBy(unorderedResult, [
      (x) => x.industry,
      (x) => x.projectType,
      (x) => x.description,
    ]);

    if (!searchText) {
      return result;
    }

    return result.filter((t) =>
      t.displayName.toLowerCase().includes(searchText.toLowerCase())
    );
  };

  const args = {
    ...props,
    getData,
    format,
    chipFormat,
  } as TypeaheadProps<ServiceDescription>;

  return <TypeaheadFormField {...args} />;
};

export default ServiceDescriptionPicker;
